/**
 * Simply remove the no-js classname from the document body
 */
export const updateBodyClassname = () => {
	document.body.classList.remove('no-js');

	if (window.innerWidth < 1024) {
		const select = document.getElementById('option-select');

		select.onchange = function () {
			const elmnt = document.getElementById('scroll-to-here');
			elmnt.scrollIntoView();
		};
	}
};
